import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../Defaults/Text';

interface Props {
  title: string;
  value: string | JSX.Element;
  noBorderBottom?: boolean;
  hasUnderline?: boolean;
  image?: string;
  link?: string;
}

function InfoRow({
  title,
  value,
  image,
  link,
  noBorderBottom,
  hasUnderline = false,
}: Props) {
  return (
    <Row noBorderTop={noBorderBottom}>
      <Title>{title}</Title>
      {link?
       <ValueLink href={link}>
          <ValueWrapper>
            {image && <ValueImage src={image}/>}
            <Value hasUnderline={hasUnderline}>{value}</Value>
          </ValueWrapper>
       </ValueLink>
       :
       <ValueWrapper>
          {image && <ValueImage src={image}/>}
          <Value hasUnderline={hasUnderline}>{value}</Value>
       </ValueWrapper>
      }
    </Row>
  );
}

const Row = styled(FlexRowCenterVertical)<{
  noBorderBottom?: boolean;
}>`
  padding: ${rem(12)} 0;
  border-bottom: ${({ theme, noBorderBottom }) =>
    noBorderBottom ? 0 : theme.borders.banners};
  margin: 0;

  &:last-child {
    border-bottom: 0;
  }
`;

const Text = styled(TextP)`
  font-size: ${rem(16)};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textPrimary};

  ${({ theme }) => theme.mediab.l925`
    font-size: ${rem(14)};
    line-height: ${rem(18)};
  `}
`;

const Title = styled(Text)`
  width: ${rem(150)};
  font-weight: 500;
  margin-right: ${rem(8)};
`;

const ValueLink = styled.a`
`

const ValueImage = styled.img`
  max-height: ${rem(10)};
  margin-right: ${rem(10)};
`

const ValueWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const Value = styled(Text)<{
  hasUnderline?: boolean;
}>`
  text-decoration: ${props => (props.hasUnderline ? 'underline' : 'none')};
`;

export default InfoRow;
